import KOGTextEllipsis from '@components/shared/kogTextEllipsis/kogTextEllipsis';
import KOGPreviewFile from '../kogPreviewFile/kogPreviewFile';
import * as S from './styles';
import { IconButton, Tooltip } from '@mui/material';
import { getTranslateByKey } from '@/main/services/utils';
import { GetApp } from '@mui/icons-material';

export interface GridFileResponse {
  fileUrl: string;
  fileExtension: string;
  guid: string;
  fileName: string;
}

interface ICardFileGridProps {
  readonly file: GridFileResponse;
  readonly openFileInModalCarousel: (file: GridFileResponse) => void;
  readonly canDownload?: boolean;
  readonly handleDownload?: (url: string, file?: GridFileResponse) => void;
}

function CardFileGrid({ file, openFileInModalCarousel, canDownload, handleDownload }: ICardFileGridProps) {
  const classes = S.useStyles();
  return (
    <S.Container onClick={() => openFileInModalCarousel(file)}>
      <S.AreaPreview>
        <KOGPreviewFile
          fileUrl={file.fileUrl}
          fileExtension={file.fileExtension}
          showPreview={false}
          guidFile={file.guid}
        />
      </S.AreaPreview>
      <S.AreaContent>
        <KOGTextEllipsis text={file.fileName} type="file" />
        {canDownload && (
          <Tooltip
            title={getTranslateByKey(
              'information.downloadFile'
            )}>
            <IconButton
              className={classes.buttonBaseDeletePreview}
              id={`id-${file.fileName}-btn-download-${file.guid}`}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                if (handleDownload){
                  handleDownload(file.fileUrl, file);
                }
              }}>
              <GetApp fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </S.AreaContent>
    </S.Container>
  );
}

export default CardFileGrid;
